<section class="features-area">
    <div class="container-fluid p-0">
        <div class="row m-0">
            <div class="col-lg-3 col-sm-6 col-md-6 p-0">
                <div class="single-features-box">
                    <div class="inner-content">
                        <h3>Million Learners</h3>
                        <p>Free online courses from the world’s leading experts. Join 13 million learners today.</p>
                        <a routerLink="/" class="default-btn"><i class='bx bx-log-in-circle icon-arrow before'></i><span class="label">Learn More</span><i class="bx bx-log-in-circle icon-arrow after"></i></a>
                    </div>
                </div>
            </div>
            <div class="col-lg-3 col-sm-6 col-md-6 p-0">
                <div class="single-features-box">
                    <div class="inner-content">
                        <h3>Million Graduates</h3>
                        <p>Free online courses from the world’s leading experts. Join 13 million learners today.</p>
                        <a routerLink="/" class="default-btn"><i class='bx bx-log-in-circle icon-arrow before'></i><span class="label">Learn More</span><i class="bx bx-log-in-circle icon-arrow after"></i></a>
                    </div>
                </div>
            </div>
            <div class="col-lg-3 col-sm-6 col-md-6 p-0">
                <div class="single-features-box">
                    <div class="inner-content">
                        <h3>500K Courses</h3>
                        <p>Free online courses from the world’s leading experts. Join 13 million learners today.</p>
                        <a routerLink="/" class="default-btn"><i class='bx bx-log-in-circle icon-arrow before'></i><span class="label">Learn More</span><i class="bx bx-log-in-circle icon-arrow after"></i></a>
                    </div>
                </div>
            </div>
            <div class="col-lg-3 col-sm-6 col-md-6 p-0">
                <div class="single-features-box">
                    <div class="inner-content">
                        <h3>145+ Countries</h3>
                        <p>Free online courses from the world’s leading experts. Join 13 million learners today.</p>
                        <a routerLink="/" class="default-btn"><i class='bx bx-log-in-circle icon-arrow before'></i><span class="label">Learn More</span><i class="bx bx-log-in-circle icon-arrow after"></i></a>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="slideshow-box">
        <ul class='slideshow-slides'>
            <owl-carousel-o [options]="slideShowSlides">
                <ng-template carouselSlide>
                    <li><span class="bg3"></span></li>
                </ng-template>
                <ng-template carouselSlide>
                    <li><span class="bg2"></span></li>
                </ng-template>
                <ng-template carouselSlide>
                    <li><span class="bg1"></span></li>
                </ng-template>
                <ng-template carouselSlide>
                    <li><span class="bg4"></span></li>
                </ng-template>
                <ng-template carouselSlide>
                    <li><span class="bg5"></span></li>
                </ng-template>
            </owl-carousel-o>
        </ul>
    </div>
</section>